import { z } from 'zod';
import { ATTRIBUTION_UPLOAD_INPUT_TYPES } from '@fortem-monorepo/constants';
import { fileInputSchema } from '../../shared';
export const uploadFilesSchema = z.object({
    files: fileInputSchema,
});
export const uploadAttributionEntrySchema = uploadFilesSchema.extend({
    input_type: z.enum(ATTRIBUTION_UPLOAD_INPUT_TYPES),
});
export const runDataExtractSchema = z.object({
    value_date: z.string(),
});
export const discrepanciesParamsSchema = z.object({
    fund_name: z.string(),
    value_date: z.string(),
});
export const updatePNLDiscrepancySchema = z.object({
    rowData: z.unknown(),
    updatedField: z.string(),
    oldValue: z.unknown(),
    newValue: z.unknown(),
});
export const runFixedIncomeSchema = z.object({
    value_date: z.string(),
    value_date_mo: z.string(),
});
export const sendFixedIncomeEmailSchema = z.object({
    value_date: z.string(),
});
